module.exports = __webpack_public_path__ + "img/enquiry-fab-zh-CN.617b3fb.svg";